import { defineStore } from "pinia";

export const useSearchStore = defineStore("search", {
  state: () => ({
    query: "",
    results: [],
    lastFetchedAt: null
  }),
  actions: {
    setQuery(q) {
      this.query = q || "";
    },
    setResults(list) {
      this.results = Array.isArray(list) ? list : [];
      this.lastFetchedAt = Date.now();
    },
    clear() {
      this.query = "";
      this.results = [];
      this.lastFetchedAt = null;
    }
  },
  persist: {
    key: "gpet-search",
    storage: sessionStorage,
    paths: ["query", "results", "lastFetchedAt"]
  }
});
